module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "meetingstatus",
    class: _vm.colorStyle
  }, [_c('span', {
    staticClass: "meetingstatus__type"
  }, [_vm._v(_vm._s(_vm.type) + ":")]), _c('br'), _vm._v(_vm._s(_vm.status))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31bec3bd","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/components/status/MentoringMeetingStatus.vue
// module id = 54a56444782d13e17ae0
// module chunks = 89